export default __webpack_public_path__ + "static/media/newspaper.bb573c6e.png";